import {
  getContrastLabel,
  getFontSizeLabel,
} from "../settingsUtils/settingsUtils";

export const FONT_SIZES_OPTIONS = [
  { value: "small", label: getFontSizeLabel("small") },
  { value: "standard", label: getFontSizeLabel("standard") },
  { value: "large", label: getFontSizeLabel("large") },
  { value: "very-large", label: getFontSizeLabel("very-large") },
];

export enum CONTRAST_ENUM {
  STANDARD = 0,
  WHITE = 1,
  DARK = 2,
}

export const CONTRAST_OPTIONS = [
  {
    value: CONTRAST_ENUM.STANDARD.toString(),
    label: getContrastLabel(CONTRAST_ENUM.STANDARD),
  },
  {
    value: CONTRAST_ENUM.WHITE.toString(),
    label: getContrastLabel(CONTRAST_ENUM.WHITE),
  },
  {
    value: CONTRAST_ENUM.DARK.toString(),
    label: getContrastLabel(CONTRAST_ENUM.DARK),
  },
];
